import Vue from "vue";
import authAxios from "@/plugins/authAxios";

export const globalData = Vue.observable({
  org: null
});

export function fetchOrg() {
  if (!globalData.org) {
    return authAxios.get("/api/org").then(response => {
      globalData.org = response.data;
      if (globalData.org.type === "volunteer") {
        if (window.location.hostname === "shokai.hygiene.jc3-learning.org") {
          document.title = "広げよう、コンテスト";
        } else {
          document.title = "ボランティア研修";
        }
      }
      return globalData.org;
    });
  }
  return Promise.resolve(globalData.org);
}
